import './styles/SelectionBox.scss';
import { useState, useEffect, useRef } from 'react';

//mui icons
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';
import { resultingClientExists } from 'workbox-core/_private';

interface Props {
    selectionList: any[], //[{ key: '', value: '' },{ key: '': value: '' }]
    selectingKey: string, SetSelectingKey: any,
    placeholder?: string,
    unselectionList?: any[],
    direction?: string //up, down, left, right, default down
    displayKey?: boolean,
    disabled ? : boolean,
    className? : string
    // dropContainStyle?: any //style the SelectionBox container style
    // dropButtonStyle?: any //style the frontmost presented dropdown button
    // dropContentStyle?: any//style the dropdown menu background container
    // dropMenuStyle?: any//style the dropdown menu buttons
}

const SelectionBox: React.FC<Props> = ({ selectionList, selectingKey, placeholder, SetSelectingKey, unselectionList, direction, displayKey, disabled, className/*, dropContainStyle, dropButtonStyle, dropContentStyle, dropMenuStyle*/ }) => {
    //state
    const [isSelecting, SetIsSelecting] = useState(false);
    const [dropDirection, SetDropDirection] = useState('down');
    // const [_dropContainStyle, SetDropContainStyle] = useState({
    //     width: 'auto', height: '100%', flex: '1',
    //     backgroundColor: 'transparent', border: 'none'
    // });
    // const [_dropButtonStyle, SetDropButtonStyle] = useState<any>({
    //     width: '100%', height: '100%',
    //     backgroundColor: '#1a1a1a',
    //     color: '#e6e6e6', fontSize: '40%', fontFamily: 'arial',
    //     borderRadius: '0', boxShadow: '0 0 0 0 #000000'
    // });
    // const [_dropContentStyle, SetDropContentStyle] = useState<any>({
    //     width: '100%', height: '100%', padding: '3% 0 3% 0',
    //     backgroundColor: '#808080',
    //     color: '#e6e6e6', fontSize: '40%', fontFamily: 'arial'
    // });
    // const [_dropMenuStyle, SetDropMenuStyle] = useState<any>({
    //     backgroundColor: 'transparent', borderRadius: '.1vw'
    // });
    //ref
    const selectBtnMaskRef = useRef<HTMLDivElement>(null);

    //add mouse click listener onstart
    useEffect(() => {
        window.addEventListener('mousedown', (e: MouseEvent) => OnMouseDown(e), false);

        return (() => {
            window.removeEventListener('mousedown', (e: MouseEvent) => OnMouseDown(e), false);
        });
    }, []);

    //watch for direction update boxDropdownDirection
    useEffect(() => {
        if (direction != undefined)
            SetDropDirection(direction);
    }, [direction]);

    //render ui function
    const RenderSelectBtn = () => {
        switch (dropDirection) {
            case 'down':
                return (
                    <button type='button' className='SelectionBox-select-btn dropButtonStyle' onClick={() => SetIsSelecting(!isSelecting)} disabled={disabled != undefined ? disabled : false} /*{_dropButtonStyle}*/>
                        <span className='SelectionBox-select-btn-label'>{GetValueByKey(selectingKey)}</span>
                        <ArrowDropDown />
                        <div className='SelectionBox-select-btn-mask' ref={selectBtnMaskRef} />
                    </button>
                );
            case 'up':
                return (
                    <button type='button' className='SelectionBox-select-btn dropButtonStyle' onClick={() => SetIsSelecting(!isSelecting)} disabled={disabled != undefined ? disabled : false}  /*{_dropButtonStyle}*/>
                        <span className='SelectionBox-select-btn-label'>{GetValueByKey(selectingKey)}</span>
                        <ArrowDropUp />
                        <div className='SelectionBox-select-btn-mask' ref={selectBtnMaskRef} />
                    </button>
                );
        }
    }

    //ui-function
    const OnSelectionBtnClicked = (key: string) => {
        // console.log('selectBtnClicked!');
        SetSelectingKey(key);
        SetIsSelecting(false);
    }
    const OnMouseDown = (e: Event) => {
        if (e.target != undefined) {
            const target = e.target as HTMLElement;
            if (!target.classList.contains('SelectionBox-selection-btn')
                && !target.classList.contains('SelectionBox-select-btn')
                && target != selectBtnMaskRef.current)
                SetIsSelecting(false);
        }
    }

    //exe function
    const GetValueByKey = (key: string) => {
        let value = placeholder != undefined ? placeholder : '';
        selectionList.map((selection: any) => {
            if (selection['key'] == key)
                value = selection['value'];
        });
        return value;
    }
    const CheckShouldDisabled = (selection: any) => {
        let shouldDisabled = false;
        if (unselectionList != undefined && unselectionList.length > 0) {
            for (let i = 0; i < unselectionList.length; i++) {
                if (unselectionList[i]['key'] == selection['key']) {
                    shouldDisabled = true;
                    break;
                }
            }
        }
        return shouldDisabled;
    }
    // const MergeStyle = (styleA: any, styleB: any) => {
    //     let result = { ...styleB };
    //     for (let i = 0; i < Object.keys(styleA).length; i++) {
    //         result[Object.keys(styleA)[i]] = styleA[Object.keys(styleA)[i]];
    //     }
    //     return result;
    // } ---deprecated of unused

    return (
        <div className={'SelectionBox dropContainStyle ' + (className ? className : '')} /*style={_dropContainStyle}*/>
            {
                RenderSelectBtn()
            }
            <div className={'SelectionBox-select-menu dropMenuStyle ' + (isSelecting ? 'show' : 'hide') + ' ' + (dropDirection)} /*style={_dropMenuStyle}*/>
                {
                    selectionList.map((selection: any, i) => {
                        return (
                            <button type='button' key={selection + '-' + i} className='SelectionBox-selection-btn dropContentStyle' disabled={CheckShouldDisabled(selection)} onClick={() => OnSelectionBtnClicked(selection['key'])} /*style={_dropContentStyle}*/>{
                                displayKey == undefined || !displayKey ?
                                    selection['value']
                                    :
                                    selection['key']
                            }</button>
                        );
                    })
                }
            </div>
        </div>
    );
}
export default SelectionBox;